import React, { useState, useEffect, useRef } from 'react';
import './Register.css';
import { MdClose } from "react-icons/md";
import { useNavigate, useLocation, Link } from 'react-router-dom';

import { PageTitle, IFrameComponent, Scanner, Modal, MessageModal } from '../../../components';
import { FaUserAlt, FaEnvelope, FaLock, FaRegEdit, FaPhone, FaRegCreditCard, FaQrcode } from 'react-icons/fa';
import { CiBarcode } from 'react-icons/ci';


// Funcode scaner
import Reader from '../../../components/FuncodeDecoder'
import { FaXmark } from "react-icons/fa6";
import { LuScanLine } from "react-icons/lu";

import Cookies from 'js-cookie';
import { useTokenCheck, getUserProfile, getLineUser, callRegister, callUpdateUserProfile } from '../../../constants';
import CookieConsentModal from '../../../components/CookieConsentModal/CookieConsentModal';

const Register = () => {
  const { nickName, isRegister, isCanExecute } = useTokenCheck();

  const navigate = useNavigate();
  // #region 需要密碼，返回要前往會員中心

  const location = useLocation();

  // Louis Add new function: 取得QueryParams
  // 當Query String中的變數action=update, 表示為更新資料

  const getQueryParams = () => {
    const searchParams = new URLSearchParams(location.search);
    const params = {};
    searchParams.forEach((value, key) => {
      params[key] = value;
    });
    return params;
  };

  const queryParams = getQueryParams();
  const [action, setAction] = useState("new");//預設註冊

  useEffect(() => {
    if (queryParams["action"] !== undefined && queryParams["action"] !== "") {
      setAction(queryParams["action"]);
    }
  }, [queryParams]);

  // Louis: 完成傳入參數的檢查


  const [isApiHavePassword, setApiHavePassword] = useState(false);//預設註冊

  const [validatePassword, setValidatePassword] = useState('');

  const validatePasswordRef = useRef(null);

  const handleValidatePasswordChange = (e) => {
    const value = e.target.value;
    setValidatePassword(value);
  };

  const validateLength = (value) => {
    return value.trim().length === 0;
  };

  const setNextPage = (errorCode) => {
    if (action === "update" && errorCode === '0842') {
      //到手機驗證頁面後，驗證完畢要引導到會員中心
      navigate("/PhoneVerify", { state: { nextPage: "/MemberProfile" } })
    } else if (action === "update") {
      navigate("/MemberProfile");
    } else if (action === "new") {
      navigate("/PhoneVerify");
    }
  };

  // #endregion

  const [Name, setName] = useState('');
  const [Mobile, setMobile] = useState('');
  const [RTMemberNo, setRTMemberNo] = useState('');
  const [Password, setPassword] = useState('');
  const [ConfirmPassword, setConfirmPassword] = useState('');
  const [Errors, setErrors] = useState({});
  const [userProfileData, setUserProfileData] = useState(null);

  const agreePolicyRef = useRef(null);
  const agreeeLineAuthRef = useRef(null);

  const handleNameChange = (e) => {
    const value = e.target.value;
    setName(value);
  };

  const handleMobileChange = (e) => {
    const value = e.target.value.replace(/\D/g, ''); // 移除所有非數字字符
    setMobile(value);
  };

  const handleRTMemberNoChange = (e) => {
    const value = e.target.value;
    setRTMemberNo(value);
  };

  const handlePasswordChange = (e) => {
    const value = e.target.value;
    setPassword(value);
  };

  const handleConfirmPasswordChange = (e) => {
    const value = e.target.value;
    setConfirmPassword(value);
  };

  useEffect(() => {
    if (!isCanExecute) return;
    const chacngeRegistreProcessing = () => {
      if (Cookies.get('cookieConsent') === 'accepted') {

        if (Cookies.get('isRegistreProcessing') === 'true') {
          setApiHavePassword(false);//不需要密碼
        } else {
          setApiHavePassword(true);
          if (action === "new") {
            setAction('update');
          }
        }
      } else {

        // 沒有同意 Cookie 的情況
      }
    }

    const getLineUserToName = () => {
      if (Cookies.get('cookieConsent') === 'accepted') {
        Cookies.set('isRegistreProcessing', true);
        setApiHavePassword(false);//不需要密碼

      } else {

        // 沒有同意 Cookie 的情況
      }
      getLineUser().then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果
            setName(payload.data.nickName);
          }
        }
        chacngeRegistreProcessing();
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    }

    if (isRegister) {
      getUserProfile().then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            setName(payload?.data?.nickName ? payload.data.nickName : '');
            setMobile(payload?.data?.mobileNo ? payload.data.mobileNo : '');
            setRTMemberNo(payload?.data?.vipCard?.cardNo ? payload.data.vipCard.cardNo : '');
            setUserProfileData(payload.data);
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          }

          chacngeRegistreProcessing();

        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    } else {
      getLineUserToName();
    }

  }, [isCanExecute]);

  const validateRegisterPassword = (password) => {
    // 密碼需至少6個字符，且包含至少一個數字和一個字母
    const re = /^(?=.*[A-Za-z])(?=.*\d)[A-Za-z\d]{6,}$/;
    return !re.test(String(password));
  }

  const handleSubmit = (event) => {
    event.preventDefault(); // Prevent the default form submission behavior
    let tempErrors = {};
    let isPass = true;

    if (validateLength(Name)) {
      tempErrors['name'] = "請填寫您的暱稱";
      isPass = false;
    }

    if (validateLength(Mobile)) {
      tempErrors['mobile'] = "請填寫您的手機";
      isPass = false;
    } else if (Mobile.length != 10) {
      tempErrors['mobile'] = "請確認填寫的是手機號碼";
      isPass = false;
    }

    if (action === "new") {
      if (validateLength(Password)) {
        tempErrors['password'] = "請填寫您的密碼";
        isPass = false;
      } else if (validateRegisterPassword(Password)) {
        tempErrors['password'] = "密碼需至少6個字符，且包含至少一個數字和一個字母";
        isPass = false;
      }

      if (Password !== ConfirmPassword) {
        tempErrors['confirmPassword'] = "請確認密碼是否一致";
        isPass = false;
      }

      if (agreePolicyRef.current && !agreePolicyRef.current.checked) {
        tempErrors['agreePolicy'] = "請確認同意後並勾選";
        isPass = false;
      }

      if (agreeeLineAuthRef.current && !agreeeLineAuthRef.current.checked) {
        tempErrors['agreeeLineAuth'] = "請確認同意後並勾選";
        isPass = false;
      }
    }
    setErrors(tempErrors);

    if (!isPass) return;

    if (isApiHavePassword && validateLength(validatePassword)) {
      const handleError = () => {
        setValidatePassword('');
        if (validatePasswordRef.current) {
          validatePasswordRef.current.focus();
        }
      };
      MessageModal.alert('請輸入密碼進行驗證', handleError);
      return;
    }

    if (isApiHavePassword) {

      const sendApiUpdateUserProfile = () => {
        let formData = {
          "nickName": Name,
          "mobileNo": Mobile,
          "vipCardNo": RTMemberNo
        }

        callUpdateUserProfile(formData, validatePassword).then(payload => {
          const isPayloadValid =
            payload?.status !== undefined &&
            payload?.errorCode !== undefined &&
            payload?.data !== undefined &&
            payload?.errorMessage !== undefined;

          if (isPayloadValid) {
            if (payload.status === 0 && payload.errorCode === '0000') {
              // 處理結果
              setNextPage();
            } else if (payload.status === 0 && payload.errorCode === '0842') {
              // 處理結果
              setNextPage(payload.errorCode);
            } else if (payload.status === 1 &&
              (payload.errorCode === '9997' || payload.errorCode === '9998')) {
              //未登入
              let errorMessage = "Token過期，或發生異常，需要重新登入！";
              MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
            } else if (payload.status === 1 && payload.errorCode === '9996') {
              //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
              let errorMessage = "查無此會員，或發生異常，需要重新登入！";
              MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
            } else {
              let errorMessage = payload.errorMessage;
              MessageModal.alert(errorMessage);
            }
          }
        }).catch(error => {
          console.error('Error during API call:', error);
        });
      }

      let userProfileDataCardNo = userProfileData?.vipCard?.cardNo ? userProfileData.vipCard.cardNo : '';

      if (userProfileDataCardNo != ''
        && userProfileDataCardNo !== RTMemberNo) {
        //會員卡號做過變更

        const handleClose = () => {
          setRTMemberNo(userProfileDataCardNo);
        };

        const handleOk = () => {
          sendApiUpdateUserProfile();
        };
        MessageModal.confirm('確定會員卡號變更?', handleOk, handleClose);
        return;
      } else {
        sendApiUpdateUserProfile();
      }

    } else {
      let formData = {
        "nickName": Name,
        "mobileNo": Mobile,
        "password": Password,
        "vipCardNo": RTMemberNo
      }
      callRegister(formData).then(payload => {
        const isPayloadValid =
          payload?.status !== undefined &&
          payload?.errorCode !== undefined &&
          payload?.data !== undefined &&
          payload?.errorMessage !== undefined;

        if (isPayloadValid) {
          if (payload.status === 0 && payload.errorCode === '0000') {
            // 處理結果
            setNextPage();
          } else if (payload.status === 1 &&
            (payload.errorCode === '9997' || payload.errorCode === '9998')) {
            //未登入
            let errorMessage = "Token過期，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else if (payload.status === 1 && payload.errorCode === '9996') {
            //查無此會員，只有被刪帳號或未完成註冊流程第一頁，理論上一進頁面tokenInfo就會擋掉
            let errorMessage = "查無此會員，或發生異常，需要重新登入！";
            MessageModal.alert(errorMessage, () => navigate('/lineLogin'));
          } else {
            let errorMessage = payload.errorMessage;
            MessageModal.alert(errorMessage);
          }
        }
      }).catch(error => {
        console.error('Error during API call:', error);
      });
    }
  };

  //   const redirectToAnotherSite = () => {
  //     const targetUrl = `https://liff.line.me/2005564732-X7QkNzM3`;
  //     const returnURL = encodeURIComponent('http://localhost:3000/test');
  //     const remark = encodeURIComponent('123456');
  //     const queryParams = `?returnURL=${returnURL}&debug=0&remark=${remark}`;
  //     window.location.href = targetUrl + queryParams;
  // };

  // Funcode ref code:

  const [latency, setLatency] = useState(false);

  const scanSuccessBeep = useRef();
  const [readerClass, setReaderClass] = useState('readerClass');

  const handleScan = (data) => {

    console.log('解碼器response', data);
    if (!data?.content) return;

    var result = data.content;
    if (scanSuccessBeep.current !== null) {
      scanSuccessBeep.current.pause()
      scanSuccessBeep.current.currentTime = 0
      scanSuccessBeep.current.play()
    }

    changeReaderState();
    setRTMemberNo(result);
    return;
  };

  const [showModal, setShowModal] = useState(false);

  const changeReaderState = () => {

    if (showModal) {
      setLatency(false);
      console.log('close the Modal!, latency:', latency);
    } else {
      setLatency(200);
      console.log('Open the Modal!, latency:', latency);
    }

    setShowModal(!showModal);

  }

  // 顯示隱私權條款;

  const [isPolicyVisible, setIsPolicyVisible] = useState(false); // 初始状态，Div1 可见，Div2 隐藏

  const showPolicy = () => {
    setIsPolicyVisible(!isPolicyVisible);
    // alert('openPolicy');
  };

  const clickAgreePolicy = () => {
    // alert('agreePolicy');
    // document.getElementById('register').focus();

    if (action === "new") {
      agreePolicyRef.current.checked =true;
      agreeeLineAuthRef.current.checked =true;
    }
  
    setIsPolicyVisible(!isPolicyVisible);
  }

  useEffect(() => {
    setTimeout(() => {
      window.scrollTo(0, 0);
    }, 1000); // 延迟 100 毫秒后滚动
  }, []);

  // 啟動與關閉攝影機
  // const changeReaderState = () => {

  //   setShowModal(!showModal);

  //   if(!showModal) {
  //     setLatency(false);
  //     console.log('Clode the Modal!, latency:', latency);
  //   } else {
  //     setLatency(500);
  //     console.log('Open the Modal!, latency:', latency);
  //   }


  // };
  // 結束

  return (
    <>
      {/* 確認是否使用cookies */}
      <CookieConsentModal />
      {/* {showIframe && <IFrameComponent src={src} />} */}
      {/* Page Title */}
      {action === "new" && <PageTitle title={'加入會員'} page={'register'} />}
      {action === "update" && <PageTitle title={'修改會員資料'} page={'modify-member'} />}
      <section className='register' id="register">
        {/* <div style={{ width: '800px', height: '600px' }}>
      <ScanditBarcodeScanner licenseKey="Aq8Eoxf0M4oTBgMovg0gfv0KrWueI64Xkx3zF4EGcfTVcNNkTyt9Z4kjgGOVUWWJv3NpkEUqp8BNWpX77CxOB2UHm3YpZDecYlCfH08Wve+xCOFhizbbUuIaU+HhZTOboXxz550C4eTgSRkQunONOyR7ZOK7VI7rNX06a5p/2IT7Qu2lERcAZKxNT13YWu1JJkpx1ddVvsHnX70vs3D6ZQxKbfo3VbSLm2iSeZIVsDy7SKGPaEIBYXFlu+qgVZvu9GEmZY5x1jlZQMJH9kChyfpkNbEQFzjrKXBz7xtxlY2PTgwBthbvrGVb7oSmYNmWeVS44a5l+HqoSW3nyF20dpp99527IaSQ5QcVdrJuEGeUPPlc3TsQKNtzuJ5ia+vwJAvWHc59vE4rabmNWntQi4o9+LsoTheJlnOGs41OraozYcGhq05Y3nZi8CXPR2olmHi37rdfjOgfXt1BFA0hB759Gy5NUZpzXHQkQpVNONBJdqaHyGZFtSBxAhWvI5p3GVPeU7FBiTNJXfhkvVPbTwsGpnFLBgCuxE+lEENp/7rvU8CHS5/3CWgI9FF4wKzrQ5S5mvrBRsbqM2Sor1trBBgJ0VF9YxmYwyeG6Ge96aryI5trwk7//H4Wj4PIs3JAPHOSXMy2b2oWkooXNrm+kmA1JBBKVmRnsLS0SI4lLwr7v78XEz7hlgSFcRViWlkPLtli366uTVS+8H/6Y3AXbBYyd9NDlz7herTHAyMw370EJRpp0MC9xvEAFNTJFR39nuN5dk8qT2uK9u87OgO1eaivQLPX6VHiLnSxEhMengGXnjg/PG67XXJn9Gz86h3fI09mT26cUwSiDFKKzwOV7Q0B4i7qmrN4LjSKRc+6ZMBSkZZRP/3O4Hb3HCnD7Q63k/HRrVHc0VgZCkkZ8zUjYVCFgI63Igt5CiWYKXyaqxwOUO4VbFoTXyqqUzmaRpxpAVJnQmZqIWSxT/icQ046nuorK+n7nJHO27icy+X03GsUNuwpTgdn4H/vgh1nSuAgYRdcU6rZ4Qf/VWecN5DgX6sNn8aRCoEy+FfJdpDHQovnIRs2Xe2gR+Z3apAkTTO4I2E1/JPsMn0F7kcnRArIApyiB3ac5XtvGFW5GfX41/MKCBibCVCZrC+vQvb4eQ2pDPgEawAZcHC3NTMl8DveEDbsXKgVsiYA0kdUXj06MuZLNzyLY4LneeePGav3MOMCI9ywyH7e" />
    </div> */}

        {/* Registration Form */}
        <form className='account-form' onSubmit={handleSubmit}>

          {/* User Icon */}
          <div className='icon'><FaRegEdit /></div>

          {/* Heading for the register form */}
          <h3>會員基本資料</h3>

          {/* Name Input */}
          <div className="input-field">
            <label htmlFor="name"><FaUserAlt /></label>
            <input type="text" name="name" placeholder="填寫您的暱稱" id="name" className="box"
              maxLength="20" value={Name} onChange={handleNameChange} />
          </div>
          {Errors.name && <div className="error-message">{Errors.name}</div>}

          {/* Ｍobile Input */}
          <div className="input-field">
            <label htmlFor="mobile"><FaPhone /></label>
            <input type="text" name="mobile" placeholder="填寫您的手機" id="email" className="box"
              maxLength="10" value={Mobile} onChange={handleMobileChange} />
          </div>
          {Errors.mobile && <div className="error-message">{Errors.mobile}</div>}

          {/* RTMemberNo Input */}
          <div className="input-field">
            <label htmlFor="rtmemberno"><FaRegCreditCard /></label>
            <input type="text" name="rtmemberno" placeholder="點選右方ICON開啟相機掃碼或直接輸入" id="rtmemberno" className="box"
              value={RTMemberNo} onChange={handleRTMemberNoChange} />

            {/* <div className="fieldNoticeIcon" onClick={() => setShowIframe(true)} > */}
            <div className="fieldNoticeIcon" >
              <CiBarcode onClick={changeReaderState} className="openReaderIcon" />
              {/* <CiBarcode onClick={() => {
                        setScannedName('rtmemberno');
                        setLatency(500); 
                      }} /> */}
            </div>
          </div>
          {Errors.rtmemberno && <div className="error-message">{Errors.rtmemberno}</div>}
          <div className='notice'>
            <label >您需要<span>綁定大全聯聯名卡會員卡號</span>，才能開通聰明繳費服務
            </label>
          </div>
          <div className="input-field">
            <img id="rtmart-card" src="/images/rtmart-card-image.png" alt="大全聯聯名卡示意圖" />
          </div>


          {action === "new" && (
            <>
              {/* Password Input */}
              <div className="input-field">
                <label htmlFor="password"><FaLock /></label>
                <input type="password" name="new-password" placeholder="填寫您的密碼" id="password" className="box"
                  maxLength="16" value={Password} onChange={handlePasswordChange} />
              </div>
              {Errors.password && <div className="error-message">{Errors.password}</div>}

              {/* Repeat Password Input */}
              <div className="input-field">
                <label htmlFor="repeat-password"><FaLock /></label>
                <input type="password" name="confirm-password" placeholder="再次填寫密碼進行驗證" id="repeat-password" className="box"
                  maxLength="16" value={ConfirmPassword} onChange={handleConfirmPasswordChange} />
              </div>
              {Errors.confirmPassword && <div className="error-message">{Errors.confirmPassword}</div>}

              {/* Terms and Conditions Checkbox */}
              <div className='terms'>
                <input type="checkbox" name="agree-policy" id="policy-node" ref={agreePolicyRef} />
                <label htmlFor="policy-node" >我同意 </label><label onClick={showPolicy}> <span>會員與隱私權條款</span> </label>
              </div>
              {Errors.agreePolicy && <div className="error-message">{Errors.agreePolicy}</div>}

              {/* Terms and Conditions Checkbox */}
              <div className='terms'>
                <input type="checkbox" name="agreee-line-auth" id="agree-line" ref={agreeeLineAuthRef} />
                <label htmlFor="agree-line">我已經閱讀並同意<span>使用Line登入</span>。</label>
              </div>
              {Errors.agreeeLineAuth && <div className="error-message">{Errors.agreeeLineAuth}</div>}




            </>
          )}

          {action === "update" &&
            <div className="validatePassword">
              <div className="input-field">
                <label htmlFor="validate-password"><FaLock /></label>
                <input type="password" name="validate-password" placeholder="如果需要修改資料，需填入密碼。" id="validate-password" className="box"
                  maxLength="16" value={validatePassword} onChange={handleValidatePasswordChange} ref={validatePasswordRef} />
              </div>
              <div className='notice'>
                <label >為了保障您的資料安全性，更新需要驗證密碼。
                </label>
              </div>
            </div>
          }

          {/* Register Button */}
          <button name='submit' id='submit' className='btn'>填寫完成</button>
          {action === "update" && <Link to="/MemberProfile"><button name='ignore' id='ignore' className='btn'>回到會員中心</button></Link>}
        </form>
        {/* <Scanner /> */}
        <div className={`${'modal'} ${latency ? 'show' : 'hidden'}`} >
          <div className="modal-content" onClick={e => e.stopPropagation()}>
            <button className="close-button" onClick={changeReaderState} ><MdClose /></button>
            <div className="readerClass">
              <audio id="scan-success" src='https://confcdnnode2.azureedge.net/funeventimages/beep-normal.mp3' ref={scanSuccessBeep} />
              <Reader
                delay={latency}
                onError={(e) => console.log('decode error =>', e)}
                onScan={handleScan}
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>
        {!isPolicyVisible &&
          /* policy Window status */
          <div className='policy' id="policy">
            <iframe src="/policy.html" className='policyFrame' title="隱私權條款" />
            <center>
              <button name='policyAgree' id='policyAgree' className='btn' onClick={clickAgreePolicy} >我同意</button>
            </center>
          </div>
        }
      </section>
    </>
  );
}

export default Register;